import { render } from "./Chat-message.vue?vue&type=template&id=9f7ba2b0&scoped=true&lang=pug"
import script from "./Chat-message.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat-message.vue?vue&type=script&setup=true&lang=js"

import "./Chat-message.vue?vue&type=style&index=0&id=9f7ba2b0&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7ba2b0"]])

export default __exports__